module.exports = __webpack_public_path__ + "static/media/epic-logo.c02e775c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epic-logo.jpeg
// module id = 1235
// module chunks = 0